import { getModernThemes } from '../utils/getModernThemes';
import { getThemeIdFromParameter } from '../utils/optionalArgumentHelpers';

export default function getIsCurrentThemeModern(themeId?: string): boolean {
    themeId = getThemeIdFromParameter(themeId);
    return getModernThemes().includes(themeId);
}
